import React from "react";
import { Field, FieldArray, change, formValueSelector } from "redux-form";
import {
  InputWithIcon,
  AutoCompleteSelect,
} from "../../../../../../itrust_common/components/form";
import { useCurrentTypeHook } from "../../../../../../itrust_common/components/others/helperHooks/useCurrentTypeHook";
import DiscountField from "../../DiscountField";
import { connect } from "react-redux";
import LensType from "./LensType";
import WarrantyShieldIcon from "../../warranty/WarrantyShieldIcon";

let Lens = (props) => {
  const {
    member,
    currentEyeglass,
    pprops,
    orderStoreId,
    currentStoreOtherDetails,
    taxSettings,
  } = props;
  const currency = useCurrentTypeHook();

  const getStoreIdForSearch = () => {
    let StoreId = localStorage.getItem("StoreID");
    if (!StoreId && StoreId == null) {
      return orderStoreId;
    }
    return StoreId;
  };

  return (
    <div className="row mx-0 bg-light">
      <div className="col-12 p-5">
        <h6 className="d-inline-flex align-items-center mb-0">
          Lens
          <WarrantyShieldIcon warranty={currentEyeglass?.warranty_attributes} covers="lens" />
        </h6>
      </div>
      <div className="col-12 px-0">
        {!currentStoreOtherDetails?.stock_lens && (
          <>
            {/* First row - Lens fields */}
            <div className="d-flex align-items-start w-100">
              <FieldArray
                name={`${member}.lens_types_attributes`}
                props={{
                  pprops: pprops,
                  currentEyeglass: currentEyeglass,
                  member: member,
                }}
                component={LensType}
              />
            </div>

            {/* Second row - Tax fields */}
            {(currentEyeglass?.lens_types_attributes?.[0]?.tax_percentage !==
              undefined &&
              currentEyeglass?.lens_types_attributes?.[0]?.tax_percentage !==
                null) && (
                <div className="d-flex align-items-center ml-6 mb-5">
                  {/* Tax */}
                  <div className="d-flex align-items-center">
                    <div>
                      <label className="text-nowrap">Tax</label>
                      <Field
                        name={`${member}.lens_types_attributes[0].tax_percentage`}
                        type="number"
                        component="input"
                        className="form-control mr-1"
                        style={{ width: "60px" }}
                        disabled={!taxSettings.allow_item_tax_override}
                        onBlur={() => setTimeout(() => pprops.submit(), 500)}
                      />
                    </div>

                    <span className="mr-2 mt-7">%</span>
                  </div>

                  {/* Tax Amount */}
                  <div>
                    <label className="text-nowrap">Tax amount</label>
                    <input
                      type="text"
                      className="form-control disabled bg-light"
                      style={{ width: "80px" }}
                      value={
                        currentEyeglass?.lens_types_attributes?.[0]
                          ?.tax_amount !== undefined &&
                        currentEyeglass?.lens_types_attributes?.[0]
                          ?.tax_amount !== null
                          ? parseFloat(
                              currentEyeglass.lens_types_attributes?.[0]
                                ?.tax_amount,
                            ).toFixed(2)
                          : ""
                      }
                      readOnly
                    />
                  </div>
                </div>
              )}
          </>
        )}
      </div>
      <div className="d-flex align-items-center col-12 px-0">
        <Field
          name={`${member}[lens_material_id]`}
          displayName={`${member}[lens_material_name]`}
          component={AutoCompleteSelect}
          onChangeHook={(data) => {
            pprops.dispatch(
              change(
                "orderEyeglassForm",
                `${member}[lens_material_id]`,
                data.id,
              ),
            );
            setTimeout(() => pprops.submit(), 500);
          }}
          klass="Settings::EyeglassLensMaterial"
          additionalFilters={{ store_inventory: getStoreIdForSearch() }}
          textField="material"
          valueField="id"
          placeholder="Placeholder"
          wrapperClasses="col-4 form-group"
          className="form-control"
          label="Material"
          labelClasses="w-100"
        />
        <Field
          name={`${member}[lens_material_unit_price]`}
          type="number"
          component={InputWithIcon}
          title={currency.symbol}
          label="Unit Price"
          labelClasses="w-100"
          className="form-control"
          wrapperClasses="col-2 px-2 form-group"
          onBlur={() => setTimeout(() => pprops.submit(), 500)}
        />
        <Field
          name={`${member}[lens_material_copay]`}
          component={InputWithIcon}
          title={currency.symbol}
          label="Copay"
          labelClasses="w-100"
          className="form-control"
          wrapperClasses="col-2 px-3 form-group"
          onBlur={() => setTimeout(() => pprops.submit(), 500)}
        />
        <div className="col-3">
          <label>Discount</label>
          <DiscountField
            itemId={currentEyeglass?.id}
            cashName={`${member}[lens_material_cash_discount]`}
            percentageName={`${member}[lens_material_percentage_discount]`}
            discountTypeName={`${member}[lens_material_discount_type]`}
            defaultType={currentEyeglass.lens_material_discount_type}
            prependClasses="py-2"
            onBlur={() => setTimeout(() => pprops.submit(), 500)}
          />
        </div>
      </div>
      {((currentEyeglass?.lens_material_tax_percentage !== undefined && currentEyeglass?.lens_material_tax_percentage !== null)) && (
        <div className="col-3 pb-3">
          <div className="d-flex align-items-center">
            <div>
              <label className="text-nowrap">Tax</label>
                <Field
                  name={`${member}[lens_material_tax_percentage]`}
                  type="number"
                  component="input"
                  className="form-control mr-1"
                  style={{ width: "60px" }}
                  disabled={!taxSettings.allow_item_tax_override}
                  onBlur={() => setTimeout(() => pprops.submit(), 500)}
                />
              </div>
              <span className="mr-2 mt-7">%</span>
              <div className="pr-5">
                <label>Tax amount</label>
                <input
                  type="text"
                  className="form-control disabled bg-light"
                  style={{ width: "80px" }}
                  value={
                    currentEyeglass?.lens_material_tax_amount !== undefined &&
                    currentEyeglass?.lens_material_tax_amount !== null
                      ? parseFloat(
                          currentEyeglass.lens_material_tax_amount,
                        ).toFixed(2)
                      : ""
                  }
                  readOnly
                />
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

const selector = formValueSelector("orderEyeglassForm");

const mapStateToProps = (state) => {
  const {
    order: { order },
    currentStore,
    storeSetting,
  } = state;
  return {
    orderStoreId: order.store_id,
    currentStoreOtherDetails: currentStore.store?.other_details,
    taxSettings:
      storeSetting?.filtered_store_settings?.tax_settings?.[0]?.store_config ||
      {},
  };
};

export default connect(mapStateToProps)(Lens);
